import Component from 'inferno-component';
import { Grid, Icon } from 'semantic-ui-react';

export default class GridElement extends Component {
  render() {
    return (
      <Grid.Column textAlign='center'>
        <div style={{textAlign: 'center', marginTop: '25px', marginBottom: '5px'}}>
          <Icon className='icon' color={this.props.color} name={this.props.name} size='big'/>
        </div>

        <p style={{fontSize: '1.1rem', textAlign: 'center'}}>
          {this.props.description}
        </p>
      </Grid.Column>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/item/GridItem.js